import styled from "styled-components";

const PlaceholderImage = styled.div`
  background: url(${(props) =>
      props.url ||
      "https://cdn.sanity.io/images/qe2ul2l0/production/7793b6d999f87700b1248703c3ede583859b516c-648x648.png"})
    center no-repeat;
  background-size: 50%;
  background-color: #ddd;
  padding-bottom: 66.47727272727273%;
  width: 100%;
`;

export default PlaceholderImage;
